// Recovered compiled webpack factory 34738. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      safeCompile: function () {
        return i;
      },
      safePathToRegexp: function () {
        return o;
      },
      safeRegexpToFunction: function () {
        return s;
      },
      safeRouteMatcher: function () {
        return l;
      },
    }));
  let n = r(80413),
    a = r(31693);
  function o(e, t, r) {
    if ("string" != typeof e) return (0, n.pathToRegexp)(e, t, r);
    let o = (0, a.hasAdjacentParameterIssues)(e),
      i = o ? (0, a.normalizeAdjacentParameters)(e) : e;
    try {
      return (0, n.pathToRegexp)(i, t, r);
    } catch (i) {
      if (!o)
        try {
          let o = (0, a.normalizeAdjacentParameters)(e);
          return (0, n.pathToRegexp)(o, t, r);
        } catch (e) {}
      throw i;
    }
  }
  function i(e, t) {
    let r = (0, a.hasAdjacentParameterIssues)(e),
      o = r ? (0, a.normalizeAdjacentParameters)(e) : e;
    try {
      return (0, n.compile)(o, t);
    } catch (o) {
      if (!r)
        try {
          let r = (0, a.normalizeAdjacentParameters)(e);
          return (0, n.compile)(r, t);
        } catch (e) {}
      throw o;
    }
  }
  function s(e, t) {
    let r = (0, n.regexpToFunction)(e, t || []);
    return (e) => {
      let t = r(e);
      return !!t && { ...t, params: (0, a.stripParameterSeparators)(t.params) };
    };
  }
  function l(e) {
    return (t) => {
      let r = e(t);
      return !!r && (0, a.stripParameterSeparators)(r);
    };
  }
}
